export function getCircusAgreement({ jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/getCircusAgreements`, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: `Bearer ${jwt}` },
  })
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then(payload => ({ payload }))
    .catch(error => ({ error }))
}
